import { render, staticRenderFns } from "./multiplesingle.vue?vue&type=template&id=d20d52ee&scoped=true&"
import script from "./multiplesingle.vue?vue&type=script&lang=js&"
export * from "./multiplesingle.vue?vue&type=script&lang=js&"
import style0 from "./multiplesingle.vue?vue&type=style&index=0&id=d20d52ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d20d52ee",
  null
  
)

export default component.exports